const jobSubmissionForm = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.cvUploadTextField = document.getElementById("cv-upload-text");
    DOM.cvUploadButton = document.getElementById("cv-upload-button");
    DOM.cvInputField = document.getElementById("cv");
  };

  const uploadFile = () => {
    DOM.cvUploadTextField.addEventListener("click", () => {
      DOM.cvInputField.click();
    });

    DOM.cvUploadButton.addEventListener("click", () => {
      DOM.cvInputField.click();
    });

    DOM.cvInputField.addEventListener("change", () => {
      DOM.cvUploadTextField.value = DOM.cvInputField.files[0].name;
    });
  };

  const init = () => {
    cacheDOM();

    if (DOM.cvUploadTextField && DOM.cvUploadButton && DOM.cvInputField) {
      uploadFile();
    }
  };

  return { init };
})();

export default jobSubmissionForm;
